module.exports = __webpack_public_path__ + "static/img/ico-AppStore.5141a5d.svg";